import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * textarea: type → label → required → [Advanced: width, placeholder, rows, prefillLastValue]
 */
export function getTextareaFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      COMMON_FIELD_CONFIGS['placeholder'],
      {
        key: 'rows',
        type: 'number',
        props: {
          label: 'formBuilder.rows',
          placeholder: 'formBuilder.rowsPlaceholder',
          description: 'formBuilder.rowsHelp',
          min: 1,
          max: 20,
        },
      },
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
